import { createSelector } from 'reselect'
import getOrderLoyaltyPendingPoints from 'loyalty/selectors/checkout/order/getOrderLoyaltyPendingPoints'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getLoyaltyTransferItems from 'checkout/selectors/view/items/getLoyaltyTransferItems'
import { isLuxLoyaltyEnabledInAgentHub } from 'agentHub/selectors/isLuxLoyaltyEnabledInAgentHub'
const getOrderLoyalty = createSelector(
  (state: App.State) => state.loyalty.account,
  (state: App.State) => getOrderLoyaltyPendingPoints(state),
  (state: App.State) => state.checkout.loyalty.enrolCustomerAtCheckout,
  (state: App.State) => getIsLoyaltyEnabled(state),
  (state: App.State) => getLoyaltyTransferItems(state),
  (loyaltyAccount, pendingPoints, enrolCustomer, isLoyaltyEnabled, transferItems): App.CheckoutOrderLoyalty | undefined => {
    const doesNotHaveLoyaltyAccount = !loyaltyAccount.data && !enrolCustomer
    if ((doesNotHaveLoyaltyAccount && !isLuxLoyaltyEnabledInAgentHub) || !isLoyaltyEnabled) return

    return {
      pendingPoints,
      tier: loyaltyAccount.data?.tier ?? null,
      enrolCustomer,
      includeAirportTransfer: transferItems.length > 0,
      accountRegion: loyaltyAccount.data?.region ?? '',
    }
  },
)

export default getOrderLoyalty
